<ion-content>

  <ion-card style="position:absolute; bottom: 0; background: white;" class="ion-no-margin">
    <img style="width: 100%;" src="../../../../assets/img/Banner.png" alt="Invite Friends Banner" aria-label=" ">
    <div class="text-overlay ion-text-center">Invite friends & family</div>
    <div class="refer-friend-modal ion-text-center">

      <div class="small-message-text">
        Share and grow Retriever to build a stronger community
      </div>

      <div class="ion-text-center confirm-button">
        <ion-button expand="block" color="secondary" fill="solid" (click)="referFriend()">Copy Link
        </ion-button>
      </div>
      <div class="ion-text-center close-button">
        <ion-button expand="block" color="dark" fill="clear" (click)="dismissModal()">Close
        </ion-button>
      </div>

    </div>
  </ion-card>

</ion-content>